import React from 'react';
import RelatedProductsView from './RelatedProductsView';

const Canvas = ({ imageUrl, selectedProduct }) => {
  return (
    <div className="canvas">
      {imageUrl ? (
        <img src={imageUrl} alt="presentation content" />
      ) : selectedProduct && selectedProduct.products?.length > 0 ? (
        <RelatedProductsView
          key={selectedProduct.label} // Add this unique key
          product={selectedProduct}
        />
      ) : null}
    </div>
  );
};

export default Canvas;